import { render, staticRenderFns } from "./NewGroupSession.vue?vue&type=template&id=0daae851&scoped=true&"
import script from "./NewGroupSession.vue?vue&type=script&lang=js&"
export * from "./NewGroupSession.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0daae851",
  null
  
)

export default component.exports